import React, { useState, useEffect } from 'react';
import { createEvidenciaSeguridadObjectUrl } from '../utils/evidenciaSeguridadProxy';

export default function EvidenciaSeguridadImage({
    previewUrl,
    alt = 'Evidencia',
    className = '',
    onClick = null
}) {
    const [imageUrl, setImageUrl] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        if (!previewUrl) {
            setLoading(false);
            return;
        }

        const loadImage = async () => {
            try {
                setLoading(true);
                setError(null);

                // Usar el proxy específico para evidencias de seguridad
                const objectUrl = await createEvidenciaSeguridadObjectUrl(previewUrl);
                setImageUrl(objectUrl);
            } catch (err) {
                console.error('Error al cargar evidencia de seguridad:', err);
                setError(err.message);
            } finally {
                setLoading(false);
            }
        };

        loadImage();

        // Cleanup: revocar la URL del objeto cuando el componente se desmonte
        return () => {
            if (imageUrl) {
                URL.revokeObjectURL(imageUrl);
            }
        };
    }, [previewUrl]);

    if (loading) {
        return (
            <div className={`flex items-center justify-center bg-gray-100 dark:bg-gray-700 border border-gray-200 dark:border-gray-600 rounded-lg ${className}`}>
                <div className="animate-spin rounded-full h-6 w-6 border-b-2 border-blue-600"></div>
            </div>
        );
    }

    if (error) {
        return (
            <div className={`flex flex-col items-center justify-center bg-gray-100 dark:bg-gray-700 border border-gray-200 dark:border-gray-600 rounded-lg text-gray-500 dark:text-gray-400 ${className}`}>
                <div className="text-xl mb-1">ðŸ“·</div>
                <div className="text-xs text-center">Error</div>
            </div>
        );
    }

    if (!imageUrl) {
        return null;
    }

    return (
        <img
            src={imageUrl}
            alt={alt}
            className={className}
            onClick={onClick}
        />
    );
}
